const React = require('react');
const ReactRedux = require('react-redux');
const createReactClass = require('create-react-class');

const moment = require('moment-timezone');

const StatusBox = require('../components/StatusBox.jsx');
const DeployDiff = require('../components/DeployDiff.jsx');
const constants = require('../constants/deployment.js');

/**
 * This simple container is a locked down / readonly version of the first step
 * (git ref selector) that are shown when a deployment is waiting for approval
 * or deploy
 */
const TargetReleaseRO = createReactClass({

	getInitialState: function() {
		return {
			open: false
		};
	},

	toggleOpen: function() {
		this.setState(prevState => ({
			open: !prevState.open
		}));
	},

	render: function() {
		const props = this.props;

		if (props.length < 1) {
			return (
				<div className="section">
					<header><h4>Target release</h4></header>
				</div>
			);
		}

		let deployDiff = null;
		let linkName = 'View details';
		let caret = 'down';
		if (this.state.open) {
			deployDiff = <DeployDiff changes={props.deployment.changes} />;
			linkName = 'Hide details';
			caret = 'up';
		}

		let deployer = null;
		if (props.deployment.deployer) {
			deployer = props.deployment.deployer.name;
		}

		let deploymentDetails = props.deployment.short_sha;
		let deploymentClass = 'sha-detail';
		let deploymentLink = props.deployment.commit_url;
		if (props.deployment.package_link) {
			deploymentDetails = 'Compressed package';
			if (props.deployment.title) {
				deploymentDetails = props.deployment.title;
			}
			deploymentClass = 'package-detail';
			deploymentLink = props.deployment.package_link;
		}

		let alert = null;
		if (constants.isInvalid(props.deployment.state)) {
			alert = (
				<div className="alert alert-warning">
					This deployment is now invalid and cannot be run. A deployment has run with new changes that this deployment does not include.
				</div>
			);
		}

		return (
			<div className="section target-release">
				{alert}
				<header><h4>Target release</h4></header>
				<div>{props.ref_type_description}</div>

				<StatusBox type="default">
					<span className="label label-default text-truncate deployment-branch">{props.deployment.ref_name}</span>&nbsp;
					<a
						target="_blank"
						rel="noopener noreferrer"
						className={deploymentClass}
						href={deploymentLink}
						title={deploymentDetails}
					>
						{deploymentDetails}
					</a>&nbsp;
					<span className="deployed-detail">{props.deployment.commit_subject}</span>
					<div style={{float: "right"}}>
						<span>
							<a href={"javascript:void(0);"} onClick={this.toggleOpen}>{linkName} <i className={"fa fa-caret-" + caret}></i></a>&nbsp;
						</span>
					</div><br />

					{deployDiff}
				</StatusBox>

				<div className="row">
					<div className="col-md-4">
						<dl className="dl-horizontal">
							<dt>Environment:</dt>
							<dd>{props.environment}</dd>
							<dt>Deployment type:</dt>
							<dd>{props.deployment.deployment_type}</dd>
							<dt>Deployment time:</dt>
							<dd>{props.deployment.deployment_estimate} min</dd>
							<dt>Version:</dt>
							<dd>{props.deployment.short_sha}</dd>
						</dl>
					</div>
					<div className="col-md-6">
						<dl className="dl-horizontal">
							<dt>Requested by:</dt>
							<dd>{deployer}</dd>
							<dt>Date requested:</dt>
							<dd>{props.date_requested ? props.date_requested.format('DD/MM/YYYY h:mma') : "n/a"}</dd>
						</dl>
					</div>
				</div>
			</div>
		);
	}
});

const mapStateToProps = function(state) {
	if (typeof state.deployment.list[state.deployment.current_id] === 'undefined') {
		return {};
	}

	const current = state.deployment.list[state.deployment.current_id] || {};

	let ref_type_description = "";
	if (state.git.list[current.ref_type]) {
		ref_type_description = state.git.list[current.ref_type].description;
	}

	let date_requested = null;
	if (current.date_requested_unix) {
		date_requested = moment.unix(current.date_requested_unix)
			.tz(state.user.timezone);
	}

	return {
		deployment: current,
		date_requested: date_requested,
		environment: state.environment.name,
		ref_type_description: ref_type_description
	};
};

const mapDispatchToProps = function() {
	return {};
};

module.exports = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(TargetReleaseRO);
